import { ReactNode } from 'react';

export const PollResultBarWrapper = ({ children }: { children: ReactNode }) => (
    <div className="relative flex-1" data-testid="PollResultBar">
        {children}
    </div>
);
